import { render, staticRenderFns } from "./selection_summary_vuex.vue?vue&type=template&id=108cb9bc&"
import script from "./selection_summary_vuex.vue?vue&type=script&lang=js&"
export * from "./selection_summary_vuex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports